import { Col, Container, Row } from "react-bootstrap";
import NotificationEntryForm from "../../../Components/Forms/NotificationEntryForm/NotificationEntryForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditNotificationEntryMutation, useGetNotificationEntryByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";

export default function AddNotificationEntryPage() {

    const { notificationEntryId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetNotificationEntryByIdQuery(notificationEntryId, { skip: !notificationEntryId })
    const notificationEntryData = data || {}

    const [
        editNotificationEntry,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditNotificationEntryMutation()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const newNotificationEntry = await editNotificationEntry({
            notificationEntryId: notificationEntryId,
            notificationEntryInfo: values
        }).unwrap()
        if (newNotificationEntry._id) {
            dispatch(navigateTo(`/notification-entry/${newNotificationEntry._id}`))
        }
        return newNotificationEntry
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Notification Entry</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {notificationEntryId && notificationEntryData && !isLoading && (
                        <NotificationEntryForm
                            initialValues={{
                                ...notificationEntryData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
